import React from "react";
import { Card, Badge } from "antd";
import { WalletOutlined, LeftOutlined } from "@ant-design/icons";
import { activePrimary } from "../../../api/WalletApi";

const FOOTER_HEIGHT = 60; // adjust this based on your footer menu height

const WalletList = ({ onBack, walletList, getUserDetails }) => {
  const setActiveWallet = (id) => {
    let obj = { id };
    activePrimary(obj).then((response) => {
      if (response.status === 1) {
        getUserDetails();
      }
    });
  };

  const renderWallet = (wallet) => {
    const walletName = wallet.walletName || "Default Wallet";
    const balance = wallet.totalBalance ?? 0;

    const walletCard = (
      <Card
        hoverable
        style={{
          width: "100%",
          borderRadius: 20,
          marginBottom: 20,
          background: "linear-gradient(135deg,#434343 0%,#000000 100%)",
          boxShadow: "0 8px 18px rgba(0,0,0,0.4)",
          color: "#fff",
          position: "relative",
        }}
        bodyStyle={{ padding: "16px 20px" }}
      >
        {/* Wallet Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "clamp(14px, 4vw, 18px)",
              fontWeight: 600,
            }}
          >
            {walletName}
          </div>
          <WalletOutlined
            style={{
              fontSize: "clamp(24px, 6vw, 32px)",
              opacity: 0.85,
            }}
          />
        </div>

        {/* Balance */}
        <div style={{ marginTop: 20 }}>
          <div
            style={{
              fontSize: "clamp(12px, 3vw, 14px)",
              opacity: 0.7,
            }}
          >
            Wallet Balance
          </div>
          <div
            style={{
              fontSize: "clamp(20px, 6vw, 32px)",
              fontWeight: "bold",
              letterSpacing: 1,
              textShadow: "0 2px 4px rgba(0,0,0,0.6)",
              marginTop: 4,
            }}
          >
            ₹ {balance.toLocaleString("en-IN")}
          </div>
        </div>
      </Card>
    );

    return wallet.primaryWallet ? (
      <Badge.Ribbon
        text="Primary"
        color="green"
        key={wallet.id}
        onClick={() => setActiveWallet(wallet.id)}
      >
        {walletCard}
      </Badge.Ribbon>
    ) : (
      <div key={wallet.id} onClick={() => setActiveWallet(wallet.id)}>
        {walletCard}
      </div>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: `calc(100vh - ${FOOTER_HEIGHT}px)`, // leave space for footer
        background: "#f5f6fa",
      }}
    >
      {/* Fixed Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "12px 16px",
          background: "#f5f6fa",
          flexShrink: 0,
        }}
      >
        <LeftOutlined
          onClick={onBack}
          style={{
            fontSize: "clamp(18px, 6vw, 22px)",
            marginRight: 12,
            cursor: "pointer",
          }}
        />
        <h2
          style={{
            margin: 0,
            fontSize: "clamp(16px, 5vw, 22px)",
            flex: 1,
            textAlign: "center",
          }}
        >
          My Wallets
        </h2>
      </div>

      {/* Scrollable Wallet List */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "12px 16px",
          paddingBottom: FOOTER_HEIGHT + 16, // ensure last card isn’t hidden
          WebkitOverflowScrolling: "touch",
        }}
      >
        {walletList.map((wallet) => renderWallet(wallet))}
      </div>
    </div>
  );
};

export default WalletList;
